/* fl-exit-offer — popup de sortie honnête (27 sept. 2026).
   Structure et textes : snippets/fl-exit-offer.liquid. Style : assets/fl-exit-offer.css.
   Code et pourcentage : réglage unique de fl-conversion (FLConv.config, sinon #fl-conv-config).
   Aucun minuteur, aucune rareté, aucune collecte de courriel, aucun piège du bouton Retour.
   Test : window.FLExitOffer.open({ test: true }) ignore les délais et la fréquence
   (mais respecte les cas où il ne doit pas s'ouvrir) ; window.FLExitOffer.close(). */
(function () {
  'use strict';

  if (window.FLExitOffer) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var root = document.querySelector('[data-fl-exit]');
  if (!root) return;

  var panel = root.querySelector('[role="dialog"]');
  var btnApply = root.querySelector('[data-fl-exit-apply]');
  var btnCopy = root.querySelector('[data-fl-exit-copy]');
  var btnNo = root.querySelector('[data-fl-exit-no]');
  var statusEl = root.querySelector('[data-fl-exit-status]');
  var grab = root.querySelector('[data-fl-exit-grab]');
  if (!panel || !btnApply || !btnCopy || !statusEl) return;

  var msg = {};
  try { msg = JSON.parse(root.querySelector('[data-fl-exit-i18n]').textContent) || {}; } catch (e) { msg = {}; }
  var FR = msg.lang === 'fr';

  /* ---------- Réglages ---------- */
  var JOUR = 86400000;
  var CLE = 'fl-exit-seen';          /* localStorage : { shown: horodatage, used: horodatage } */
  var CLE_SESSION = 'fl-exit-session';
  var ATTENTE_ORDI = 8000;           /* 8 s sur la page avant la sortie par le haut */
  var ATTENTE_MOBILE = 15000;        /* 15 s sur la page */
  var PROFONDEUR_MOBILE = 0.4;       /* 40 % de la page descendue */
  var REMONTEE_MOBILE = 0.25;        /* 25 % d'écran remontés… */
  var FENETRE_MOBILE = 500;          /* …en moins de 500 ms */
  var ECART_VU = 3 * JOUR;
  var ECART_UTILISE = 30 * JOUR;
  var ECART_PLINKO = 60000;

  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (racine.charAt(racine.length - 1) !== '/') racine += '/';

  var ouvert = false;
  var enCours = false;               /* une vérification du panier est en route */
  var montreIci = false;             /* déjà montré sur cette page */
  var reposJusqua = 0;               /* après un refus « code dans le panier », on se tait un moment */
  var conf = null;
  var retourFocus = null;
  var verrou = null;
  var cssPret = false;
  var cssAttente = [];
  var plinkoVu = 0;
  var dernierRefus = '';
  var applique = false;
  var application = false;
  var minuterieFermeture = 0;

  function mouvementReduit() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }

  /* ---------- Feuille de style : chargée une fois, sans bloquer la page ---------- */
  function chargerCss(cb) {
    if (cssPret) { cb(); return; }
    cssAttente.push(cb);
    if (cssAttente.length > 1) return;
    var href = root.getAttribute('data-css');
    if (!href) { cssPret = true; viderCss(); return; }
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    l.onload = function () { cssPret = true; viderCss(); };
    l.onerror = function () { cssAttente = []; };
    document.head.appendChild(l);
  }
  function viderCss() {
    var f = cssAttente;
    cssAttente = [];
    for (var i = 0; i < f.length; i++) f[i]();
  }

  /* ---------- Code et pourcentage : réglage unique de fl-conversion ---------- */
  function lireConf() {
    var c = null;
    try { if (window.FLConv && window.FLConv.config) c = window.FLConv.config; } catch (e) { c = null; }
    if (!c || !c.code) {
      var el = document.getElementById('fl-conv-config');
      if (el) {
        try {
          var j = JSON.parse(el.textContent);
          c = (j && j.config && j.config.code) ? j.config : j;
        } catch (e) { c = null; }
      }
    }
    if (!c || !c.code) return null;
    var code = String(c.code).trim();
    var pct = Number(c.pct);
    if (!/^[A-Za-z0-9_-]{2,40}$/.test(code)) return null;
    if (!(pct > 0 && pct < 100)) return null;
    return { code: code, pct: pct };
  }

  /* ---------- Mémoire (localStorage / sessionStorage, toujours sous try) ---------- */
  function lireMemoire() {
    try {
      var v = JSON.parse(localStorage.getItem(CLE) || 'null');
      return (v && typeof v === 'object') ? v : {};
    } catch (e) { return {}; }
  }
  function ecrireMemoire(maj) {
    try {
      var v = lireMemoire();
      for (var k in maj) if (Object.prototype.hasOwnProperty.call(maj, k)) v[k] = maj[k];
      localStorage.setItem(CLE, JSON.stringify(v));
    } catch (e) { /* stockage bloqué : la limite par page suffit */ }
  }
  function recent(t, ecart) {
    var n = Date.now();
    t = Number(t) || 0;
    /* Horloge revenue en arrière : une date future n'est pas « récente » pour toujours. */
    if (t > n + JOUR) return false;
    return n - t < ecart;
  }
  function refusFrequence() {
    if (montreIci) return 'deja-montre-ici';
    try { if (sessionStorage.getItem(CLE_SESSION)) return 'deja-montre-session'; } catch (e) { /* rien */ }
    var m = lireMemoire();
    if (m.used && recent(m.used, ECART_UTILISE)) return 'code-utilise-30j';
    if (m.shown && recent(m.shown, ECART_VU)) return 'vu-moins-de-3j';
    return '';
  }

  /* ---------- Quand ne PAS s'ouvrir ---------- */
  function visible(el) {
    if (!el) return false;
    if (typeof el.checkVisibility === 'function') {
      if (!el.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return false;
    } else {
      var s = getComputedStyle(el);
      if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    }
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1 && r.bottom > 0 && r.right > 0 &&
      r.top < window.innerHeight && r.left < window.innerWidth;
  }

  function pageExclue() {
    var p = location.pathname.toLowerCase();
    var base = racine.toLowerCase();
    if (base !== '/' && p.indexOf(base) === 0) p = '/' + p.slice(base.length);
    /* Contact : /pages/contact et /pages/contact-us (celle du menu et du pied de page). */
    return /^\/(account|cart|checkouts?|pages\/contact(-us)?)(\/|$)/.test(p);
  }

  function plinkoRecent() {
    if (plinkoVu && Date.now() - plinkoVu < ECART_PLINKO) return true;
    /* Le Plinko note l'heure de son ouverture automatique au moment où il la décide :
       elle peut être encore en attente (barre de consentement). */
    try {
      var s = JSON.parse(localStorage.getItem('stw-seen-florasa') || 'null');
      if (s && s.createdAt && recent(s.createdAt, ECART_PLINKO)) return true;
    } catch (e) { /* rien */ }
    return false;
  }

  function autreDialogue() {
    var l = document.querySelectorAll('[aria-modal="true"], dialog[open]');
    for (var i = 0; i < l.length; i++) {
      var el = l[i];
      if (root.contains(el)) continue;
      if (el.closest('[aria-hidden="true"]')) continue;
      if (visible(el)) return true;
    }
    return false;
  }

  function refusContexte() {
    if (document.visibilityState && document.visibilityState !== 'visible') return 'onglet-cache';
    if (pageExclue()) return 'page-exclue';
    if (document.documentElement.getAttribute('data-flc-banner') === 'on' ||
        visible(document.getElementById('shopify-pc__banner')) ||
        visible(document.getElementById('shopify-pc__prefs'))) return 'consentement';
    if (document.querySelector('[data-cd-drawer].is-open')) return 'tiroir-ouvert';
    if (document.querySelector('[data-cu-overlay].is-open')) return 'pre-paiement-ouvert';
    if (document.querySelector('[class*="stw-overlay-"].is-active')) return 'plinko-ouvert';
    if (plinkoRecent()) return 'plinko-recent';
    if (document.querySelector('[data-ai-mobile-menu].is-open') ||
        /(^|\s)ai-menu-open/.test(document.body.className)) return 'menu-ouvert';
    var chat = document.querySelector('florasa-chat .fls-panel');
    if (chat && !chat.hidden && visible(chat)) return 'chat-ouvert';
    if (autreDialogue()) return 'autre-dialogue';
    return '';
  }

  function lirePanier() {
    return fetch(racine + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart.js ' + r.status);
      return r.json();
    });
  }

  /* Le Plinko ne prévient personne quand il s'ouvre : on note l'heure de chacun de ses
     changements d'état (observation limitée à l'attribut class de son voile). */
  function surveillerPlinko() {
    if (!('MutationObserver' in window)) return;
    var voiles = document.querySelectorAll('[class*="stw-overlay-"]');
    if (!voiles.length) return;
    var mo = new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        var t = liste[i].target;
        if (t.classList && (t.classList.contains('is-active') || liste[i].oldValue && liste[i].oldValue.indexOf('is-active') !== -1)) {
          plinkoVu = Date.now();
        }
      }
    });
    for (var i = 0; i < voiles.length; i++) {
      if (voiles[i].classList.contains('is-active')) plinkoVu = Date.now();
      mo.observe(voiles[i], { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    }
  }

  /* ---------- Tentative d'ouverture ---------- */
  function refuser(raison) {
    dernierRefus = raison;
    return { opened: false, reason: raison };
  }

  function tenter(opts) {
    var test = !!(opts && opts.test);
    if (ouvert) return Promise.resolve(refuser('deja-ouvert'));
    if (enCours) return Promise.resolve(refuser('verification-en-cours'));
    if (!test) {
      var f = refusFrequence();
      if (f) return Promise.resolve(refuser(f));
      if (Date.now() < reposJusqua) return Promise.resolve(refuser('code-dans-panier'));
    }
    conf = lireConf();
    if (!conf) return Promise.resolve(refuser('reglage-absent'));
    var c = refusContexte();
    if (c) return Promise.resolve(refuser(c));
    enCours = true;
    return new Promise(function (fin) {
      chargerCss(function () { fin(); });
      /* Feuille introuvable : on n'ouvre pas une boîte sans style. */
      setTimeout(fin, 8000);
    }).then(function () {
      if (!cssPret) throw new Error('css');
      return lirePanier();
    }).then(function (panier) {
      enCours = false;
      if (panier && panier.discount_codes && panier.discount_codes.length) {
        reposJusqua = Date.now() + 60000;
        return refuser('code-dans-panier');
      }
      /* L'état a pu changer pendant la lecture du panier. */
      var c2 = refusContexte();
      if (c2) return refuser(c2);
      if (!test) {
        var f2 = refusFrequence();
        if (f2) return refuser(f2);
      }
      ouvrir(test);
      dernierRefus = '';
      return { opened: true, reason: '' };
    }, function (e) {
      enCours = false;
      return refuser(e && e.message === 'css' ? 'style-absent' : 'panier-illisible');
    });
  }

  /* ---------- Verrou du défilement, sans saut de page ---------- */
  function verrouiller() {
    var de = document.documentElement;
    var b = document.body;
    var largeur = window.innerWidth - de.clientWidth;
    verrou = {
      ho: de.style.overflow, bo: b.style.overflow,
      sg: de.style.getPropertyValue('scrollbar-gutter'), pr: b.style.paddingRight
    };
    if (largeur > 0) {
      /* La barre de défilement disparaît : on garde sa place, sinon la page saute. */
      if (window.CSS && CSS.supports && CSS.supports('scrollbar-gutter', 'stable')) {
        de.style.setProperty('scrollbar-gutter', 'stable');
      } else {
        b.style.paddingRight = ((parseFloat(getComputedStyle(b).paddingRight) || 0) + largeur) + 'px';
      }
    }
    de.style.overflow = 'hidden';
    b.style.overflow = 'hidden';
  }
  function deverrouiller() {
    if (!verrou) return;
    var de = document.documentElement;
    var b = document.body;
    de.style.overflow = verrou.ho;
    b.style.overflow = verrou.bo;
    if (verrou.sg) de.style.setProperty('scrollbar-gutter', verrou.sg);
    else de.style.removeProperty('scrollbar-gutter');
    b.style.paddingRight = verrou.pr;
    verrou = null;
  }

  /* ---------- Remplissage et états ---------- */
  function remplir() {
    var pct = FR ? String(conf.pct).replace('.', ',') : String(conf.pct);
    var l = root.querySelectorAll('[data-fl-exit-pct]');
    for (var i = 0; i < l.length; i++) l[i].textContent = pct;
    l = root.querySelectorAll('[data-fl-exit-code]');
    for (var j = 0; j < l.length; j++) l[j].textContent = conf.code;
  }

  function libelle(bouton) {
    if (!bouton.hasAttribute('data-libelle')) bouton.setAttribute('data-libelle', bouton.textContent.trim());
    return bouton.getAttribute('data-libelle');
  }
  /* La coche suit le texte, comme « Appliqué ✓ » / « Copié ✓ » ailleurs sur le site. */
  function etat(bouton, texte, coche) {
    bouton.textContent = '';
    bouton.appendChild(document.createTextNode(texte));
    if (coche) {
      var s = document.createElement('span');
      s.className = 'fl-exit__check';
      s.setAttribute('aria-hidden', 'true');
      s.textContent = '✓';
      bouton.appendChild(s);
    }
  }
  function annoncer(texte, ton) {
    statusEl.textContent = texte || '';
    if (ton) statusEl.setAttribute('data-tone', ton);
    else statusEl.removeAttribute('data-tone');
  }
  function remettre() {
    applique = false;
    application = false;
    etat(btnApply, libelle(btnApply));
    btnApply.removeAttribute('aria-disabled');
    btnApply.removeAttribute('aria-busy');
    btnApply.removeAttribute('data-state');
    etat(btnCopy, libelle(btnCopy));
    btnCopy.removeAttribute('data-state');
    if (btnNo) etat(btnNo, libelle(btnNo));
    annoncer('');
  }

  /* ---------- Ouvrir / fermer ---------- */
  function ouvrir(test) {
    clearTimeout(minuterieFermeture);
    remplir();
    remettre();
    var a = document.activeElement;
    retourFocus = (a && a !== document.body && a !== document.documentElement) ? a : null;
    verrouiller();
    document.documentElement.classList.add('fl-exit-popup-open');
    root.classList.remove('is-in');
    root.hidden = false;
    ouvert = true;
    /* Un cadre plus tard : la transition d'entrée part de l'état initial. */
    void panel.offsetWidth;
    root.classList.add('is-in');
    try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
    document.addEventListener('keydown', surTouche, true);
    if (!test) {
      montreIci = true;
      try { sessionStorage.setItem(CLE_SESSION, '1'); } catch (e) { /* rien */ }
      ecrireMemoire({ shown: Date.now() });
    }
  }

  function fermer() {
    if (!ouvert) return;
    ouvert = false;
    document.removeEventListener('keydown', surTouche, true);
    root.classList.remove('is-in');
    var fin = function () {
      root.hidden = true;
      panel.style.transform = '';
      deverrouiller();
      document.documentElement.classList.remove('fl-exit-popup-open');
      var cible = retourFocus;
      retourFocus = null;
      if (cible && document.contains(cible) && typeof cible.focus === 'function') {
        try { cible.focus({ preventScroll: true }); } catch (e) { cible.focus(); }
      }
    };
    if (mouvementReduit()) fin();
    else minuterieFermeture = setTimeout(fin, 180);
  }

  function focusables() {
    var l = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var r = [];
    for (var i = 0; i < l.length; i++) {
      if (l[i].disabled || l[i].getAttribute('aria-hidden') === 'true') continue;
      if (l[i].getClientRects().length) r.push(l[i]);
    }
    return r;
  }

  function surTouche(e) {
    if (!ouvert) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      e.stopPropagation();
      fermer();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var premier = f[0];
    var dernier = f[f.length - 1];
    var actif = document.activeElement;
    if (!panel.contains(actif) || actif === panel) {
      e.preventDefault();
      (e.shiftKey ? dernier : premier).focus();
    } else if (e.shiftKey && actif === premier) {
      e.preventDefault();
      dernier.focus();
    } else if (!e.shiftKey && actif === dernier) {
      e.preventDefault();
      premier.focus();
    }
  }

  /* ---------- Appliquer : API de fl-conversion, sinon repli minimal ---------- */
  function appliquerVia(code) {
    if (window.FLConv && typeof window.FLConv.applyCode === 'function') {
      return Promise.resolve(window.FLConv.applyCode(code));
    }
    /* Repli : fusionne avec les codes déjà présents (l'envoi REMPLACE la liste). */
    return lirePanier().then(function (panier) {
      var codes = [];
      (panier.discount_codes || []).forEach(function (d) {
        if (d && d.code && d.code.toLowerCase() !== code.toLowerCase()) codes.push(d.code);
      });
      codes.push(code);
      return fetch(racine + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('update.js ' + r.status);
      return r.json();
    }).then(function (panier) {
      var trouve = null;
      (panier.discount_codes || []).forEach(function (d) {
        if (d && d.code && d.code.toLowerCase() === code.toLowerCase()) trouve = d;
      });
      if (trouve && trouve.applicable) return { ok: true, applicable: true, reason: 'applied' };
      /* Panier vide : Shopify garde le code et l'applique au premier article (vérifié le 27 sept.). */
      if (!panier.item_count) return { ok: true, applicable: false, reason: 'saved' };
      /* Sans effet sur ce panier : on retire ce code, comme le fait fl-conversion. */
      var reste = (panier.discount_codes || []).filter(function (d) {
        return d && d.code && d.code.toLowerCase() !== code.toLowerCase();
      }).map(function (d) { return d.code; });
      return fetch(racine + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: reste.join(',') })
      }).then(function () {
        return { ok: false, applicable: false, reason: 'not-applicable' };
      }, function () {
        return { ok: false, applicable: false, reason: 'not-applicable' };
      });
    });
  }

  function surAppliquer() {
    if (applique || application || !conf) return;
    application = true;
    btnApply.setAttribute('aria-busy', 'true');
    btnApply.setAttribute('aria-disabled', 'true');
    annoncer(msg.applying);
    var messageApi = '';
    appliquerVia(conf.code).then(function (res) {
      /* Résultat de FLConv.applyCode : { ok, applicable, reason, message }. */
      if (res && res.applicable) return 'ok';
      /* Panier vide : le code est gardé mais ne s'applique pas encore (seul cas ok sans applicable). */
      if (res && (res.reason === 'saved' || (res.ok && !res.applicable))) return 'vide';
      var r = String((res && res.reason) || '');
      if (!res || r === 'network' || r.indexOf('http-') === 0) return 'erreur';
      /* Code refusé pour ce panier (non applicable, non cumulable…) : le message de
         fl-conversion est le plus précis, et c'est le même que dans le tiroir. */
      messageApi = res.message || '';
      return 'non-applicable';
    }, function () { return 'erreur'; }).then(function (issue) {
      application = false;
      btnApply.removeAttribute('aria-busy');
      if (issue === 'ok') {
        applique = true;
        ecrireMemoire({ used: Date.now() });
        btnApply.setAttribute('data-state', 'done');
        etat(btnApply, msg.appliedBtn, true);
        if (btnNo) etat(btnNo, msg['continue']);
        annoncer(msg.applied, 'success');
      } else if (issue === 'vide') {
        /* Enregistré, pas encore appliqué : libellé et couleurs neutres (pas le vert du succès). */
        applique = true;
        ecrireMemoire({ used: Date.now() });
        btnApply.setAttribute('data-state', 'saved');
        etat(btnApply, msg.savedBtn || (FR ? 'Code enregistré' : 'Code saved'), true);
        if (btnNo) etat(btnNo, msg['continue']);
        annoncer(msg.savedEmpty);
      } else {
        btnApply.removeAttribute('aria-disabled');
        annoncer(issue === 'non-applicable' ? (messageApi || msg.notApplicable) : msg.error, 'error');
      }
    });
  }

  /* ---------- Copier ---------- */
  function copieReussie() {
    ecrireMemoire({ used: Date.now() });
    btnCopy.setAttribute('data-state', 'done');
    etat(btnCopy, msg.copiedBtn, true);
    annoncer(msg.copied, 'success');
  }
  function copieDeSecours() {
    var ta = document.createElement('textarea');
    ta.value = conf.code;
    ta.setAttribute('readonly', '');
    ta.setAttribute('aria-hidden', 'true');
    ta.tabIndex = -1;
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '0';
    ta.style.opacity = '0';
    panel.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    panel.removeChild(ta);
    try { btnCopy.focus({ preventScroll: true }); } catch (e) { btnCopy.focus(); }
    if (ok) copieReussie();
    else annoncer(msg.copyFail, 'error');
  }
  function surCopier() {
    if (!conf) return;
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(conf.code).then(copieReussie, copieDeSecours);
    } else {
      copieDeSecours();
    }
  }

  /* ---------- Liaisons ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-fl-exit-close]')) { e.preventDefault(); fermer(); return; }
    if (t.closest('[data-fl-exit-apply]')) { e.preventDefault(); surAppliquer(); return; }
    if (t.closest('[data-fl-exit-copy]')) { e.preventDefault(); surCopier(); }
  });

  /* Feuille du bas (mobile) : glisser la poignée vers le bas ferme. */
  if (grab) {
    var depart = 0;
    var ecart = 0;
    var glisse = false;
    grab.addEventListener('touchstart', function (e) {
      if (!ouvert || !e.touches || e.touches.length !== 1) return;
      glisse = true;
      depart = e.touches[0].clientY;
      ecart = 0;
      panel.style.transition = 'none';
    }, { passive: true });
    grab.addEventListener('touchmove', function (e) {
      if (!glisse || !e.touches || !e.touches.length) return;
      ecart = Math.max(0, e.touches[0].clientY - depart);
      panel.style.transform = 'translateY(' + ecart + 'px)';
    }, { passive: true });
    var lacher = function (fermerSiLoin) {
      if (!glisse) return;
      glisse = false;
      panel.style.transition = '';
      panel.style.transform = '';
      if (fermerSiLoin && ecart > 80) fermer();
      ecart = 0;
    };
    grab.addEventListener('touchend', function () { lacher(true); }, { passive: true });
    grab.addEventListener('touchcancel', function () { lacher(false); }, { passive: true });
  }

  /* ---------- Déclencheurs ---------- */
  function media(q) {
    try { return window.matchMedia(q).matches; } catch (e) { return false; }
  }
  function tempsSurPage() {
    return (window.performance && performance.now) ? performance.now() : 0;
  }

  if (media('(pointer: fine)')) {
    /* Ordinateur : la souris sort de la fenêtre par le haut (onglets, barre d'adresse). */
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 0) return;
      if (tempsSurPage() < ATTENTE_ORDI) return;
      tenter();
    });
  } else if (media('(pointer: coarse)')) {
    /* Mobile : il n'y a pas de vraie sortie. On retient une remontée franche et rapide,
       après une vraie lecture de la page. Rien sur le bouton Retour. */
    var points = [];
    var profondeur = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var t = tempsSurPage();
      var course = document.documentElement.scrollHeight - window.innerHeight;
      if (course > 0 && y / course > profondeur) profondeur = y / course;
      points.push([t, y]);
      /* On garde un point juste avant la fenêtre : c'est la position d'il y a 500 ms. */
      while (points.length > 1 && t - points[1][0] > FENETRE_MOBILE) points.shift();
      if (ouvert || enCours || t < ATTENTE_MOBILE || profondeur < PROFONDEUR_MOBILE) return;
      var haut = 0;
      for (var i = 0; i < points.length; i++) if (points[i][1] > haut) haut = points[i][1];
      if (haut - y >= window.innerHeight * REMONTEE_MOBILE) {
        points = [];
        tenter();
      }
    }, { passive: true });
  }

  function demarrer() {
    surveillerPlinko();
    /* La feuille se charge au calme, bien avant le premier déclenchement possible. */
    chargerCss(function () {});
  }
  if (document.readyState === 'complete') setTimeout(demarrer, 1000);
  else window.addEventListener('load', function () { setTimeout(demarrer, 1000); });

  window.FLExitOffer = {
    open: function (opts) { return tenter(opts || {}); },
    close: fermer,
    state: function () {
      return {
        open: ouvert,
        lastRefusal: dernierRefus,
        memory: lireMemoire(),
        config: lireConf(),
        pointer: media('(pointer: fine)') ? 'fine' : (media('(pointer: coarse)') ? 'coarse' : 'none')
      };
    }
  };
})();
